import { testimonials } from "@/mocks/archiveData";

export default function TestimonialsSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium tracking-wide text-accent-700">COMMUNITY · 用户口碑</p>
          <h2 className="mt-3 text-2xl text-foreground-950 md:text-4xl">被他们用来追查原文、核验口径</h2>
          <p className="mt-3 text-sm leading-6 text-foreground-700 md:text-base">
            从新媒体编辑到舆情研究者，越来越多的内容工作者正把快照留痕写进日常工作流。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-6">
              <div className="flex items-center gap-2 text-accent-600">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-800">“{t.text}”</blockquote>
              <figcaption className="mt-6 flex items-center justify-between border-t border-background-200 pt-4">
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
                <span className="whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
                  {t.tag}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}